// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminVisualAssetsManagerController from "./admin_visual_assets_manager_controller"
application.register("admin-visual-assets-manager", AdminVisualAssetsManagerController)

import FaqAccordionController from "./faq_accordion_controller"
application.register("faq-accordion", FaqAccordionController)
